import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const PaymentDocumentRejectedApplications = () => {
    const editApplicationPermission = checkPermission(
      permissionsConfig.editPaymentDocumentRejectedApplications.role,
      permissionsConfig.editPaymentDocumentRejectedApplications.action,
      permissionsConfig.editPaymentDocumentRejectedApplications.type
    );
      
    const deleteApplicationPermission = checkPermission(
      permissionsConfig.deletePaymentDocumentRejectedApplications.role,
      permissionsConfig.deletePaymentDocumentRejectedApplications.action,
      permissionsConfig.deletePaymentDocumentRejectedApplications.type
    );
  
    return (
      <StatusApplication appStatus="11" title="Payment Document Rejected" subTitle="Payment Document Rejected" application_type="0" pageFrom="payment-document-rejected-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
    )
}

export default PaymentDocumentRejectedApplications